import { accessTokenProvider } from '@tom-ui/utils'
import { InternalAxiosRequestConfig } from 'axios'

export const onFulfilled = async (request: InternalAxiosRequestConfig<any>) => {
  if (accessTokenProvider.get) {
    const accessToken = await accessTokenProvider.get()
    request.headers.Authorization = `Bearer ${accessToken}`
  }

  return request
}
